import { ChangeDetectionStrategy, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatStep, MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { Observable, Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { AppConfigService } from '../../core/config/app-config.service';
import { GoogleService } from '../../core/services/google.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { CommonDataService } from '../../project/services/commonData.service';
import { IGeneralTranslation } from '../../shared/interfaces/auth.interface';
import { IDropdown_SignUp, ISignUp } from '../../shared/interfaces/signup.interface';
import { IDropdownData } from '../../shared/interfaces/tools.Interfaces';
import { Defaults } from '../../shared/models/defaults';
import { Enums } from '../../shared/models/enums';
import modalSignUpSchema from '../../shared/schemas/modals/modalSignUp.json';
import { FormControlService } from '../../shared/services/form-control.service';
import { FormGroupGenerationService } from '../../shared/services/form-group-generation.service';
import { ToastService } from '../../shared/services/toast.service';
import { CaptchaComponent } from '../../shared/widgets';
import { AutoCompleteComponent } from '../../shared/widgets/form/auto-complete/auto-complete.component';
import { CheckboxComponent } from '../../shared/widgets/form/checkbox/checkbox.component';
import { InputFieldComponent } from '../../shared/widgets/form/input-field/input-field.component';
import { SelectCountryWithCodeComponent } from '../../shared/widgets/form/select-country-with-code/select-country-with-code.component';
import { SelectComponent } from '../../shared/widgets/form/select/select.component';

@Component({
    selector: 'ifc-modal-signup',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-signup.component.html',
    styleUrls: ['./modal-signup.component.scss'],
    standalone: true,
    imports: [
        InputFieldComponent,
        SelectComponent,
        AutoCompleteComponent,
        CheckboxComponent,
        CaptchaComponent,
        SelectCountryWithCodeComponent,
        MatStepper,
        MatStep,
        MatButton,
    ]
})
export class ModalSignupComponent implements OnInit, OnDestroy {
    private readonly appConfigService = inject(AppConfigService);

    private get lmsUrl(): string {
        return this.appConfigService.config()?.auth?.lmsUrl ?? '';
    }

    @ViewChild('signupScroll', { static: false }) signupScroll: ElementRef;

    captchaLoaded: boolean;
    getCaptchaResponse: any;
    loginButton: string;
    registerButton: string;
    showCloseBtn: boolean = true;
    form: FormGroup;
    schema = modalSignUpSchema;
    registerPage2Schema = modalSignUpSchema.properties.registerPage2;
    confirmationStatus = Enums.confirmationStatus;
    dropDowns = {} as IDropdown_SignUp;
    //signupStaticText: ISignUpStaticText;
    signup = {} as ISignUp;
    generalTranslation: IGeneralTranslation;
    defaults: Defaults;
    jobTitleId: any;
    jobTitleDropdownData: Array<IDropdownData>;

    filteredOptions: Observable<string[]>;

    action: Subject<any> = new Subject();


    @ViewChild(CaptchaComponent, { static: false })
    private captchaReload: CaptchaComponent;

    constructor(
        public modalRef: MDBModalRef,
        private fb: FormBuilder,
        private formGroupGenerationService: FormGroupGenerationService,
        public userPersistenceService: UserPersistenceService,
        private authService: AuthService,
        private toastService: ToastService,
        private formControlService: FormControlService,
        private googleService: GoogleService,
        private commonDataService: CommonDataService,
        private localStorageService: LocalStorageService,
        private router: Router,

        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        document.body.classList.add('signup-page');
        this.form = this.fb.group(this.formGroupGenerationService.createFormGroup(this.schema));
        this.setDefaults();
        this.getAllMastersForRegistration();
        if (!this.captchaLoaded) {
            this.getMathCaptcha();
        }
    }

    ngOnDestroy() {
        document.body.classList.remove('signup-page');
    }

    private setDefaults() {
        this.defaults = new Defaults();
        this.generalTranslation = this.defaults.generalTranslations;
        this.form.controls.registerPage2.get('phoneCode').setValue('+91');
        this.form.controls.registerPage2.get('agreeToPrivacyPolicy').setValue(false);
        this.form.controls.registerPage2.get('wishToReceiveEmail').setValue(false);
    }

    setPhoneCode(option) {
        let phoneCode = option.category;
        this.form.controls.registerPage2.get('phoneCode').setValue(phoneCode);
    }

    onJobTitleSelect(jobTitle) {
        this.jobTitleDropdownData = this.dropDowns.jobTitles;
        this.jobTitleId = jobTitle.key;
    }

    onJobTitleClear() {
        this.jobTitleId = null;
        this.form.controls.registerPage2.get('otherJobTitle').setValue('');
        this.jobTitleDropdownData = this.dropDowns.jobTitles;
    }

    onJobTitleChange(jobTitle) {
        this.jobTitleDropdownData = this.dropDowns.jobTitles;

        this.jobTitleDropdownData = this.jobTitleDropdownData.filter(option => option.text.toLowerCase().includes(jobTitle.toLowerCase()));
        this.jobTitleId = null;

        if (jobTitle === "") {
            this.jobTitleDropdownData = this.dropDowns.jobTitles;
        }
    }

    getAllMastersForRegistration() {
        this.authService.getAllMastersForRegistration(this.userPersistenceService.selectedLanguage)
            .subscribe((result: any) => {
                this.dropDowns.countries = result[0];
                this.dropDowns.jobTitles = result[1];
                this.jobTitleDropdownData = result[1];
                this.dropDowns.titles = result[2];
                this.dropDowns.registrationGender = result[3];

            
                this.cdr.markForCheck();}, error => {
                if (error.error.message == "111") {
                    this.toastService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
                }
            
                this.cdr.markForCheck();});
    }

    onCancelClick() {
        this.modalRef.hide();
        this.action.next({ status: this.confirmationStatus.cancel });
    }

    onLoginClick() {
        this.action.next({ status: 'loginClick' });
    }

    getMathCaptcha() {
        this.authService.getCaptchaImage(this.userPersistenceService.selectedLanguage)
            .subscribe((result: any) => {
                this.signup.captchaSrc = result.path + '/' + result.image;
                this.signup.captchaFileName = result.image;
                this.signup.captchaInput = '';
                this.form.controls.registerPage2.get('captchaInput').setValue('');
            
                this.cdr.markForCheck();});
    };

    onNextClick(stepper) {
        if (this.form.controls.registerPage1.valid) {
            stepper.next();
        }
        else {
            this.formControlService.callFormControlError(<FormGroup>this.form.controls.registerPage1);
        }
        this.signupScroll?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }

    recaptchaReload() {
        this.captchaReload.captchaReload();
    }
    getParams = function (url) {
        var params = {};
        var parser = document.createElement('a');
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    };
    register = function () {
        var routeURL = this.router.url;
        console.log(routeURL);
        //lms portal Routing testing
        // routeURL = 'http://localhost:58527/project/allBuildings?_lms=2.104955139.1457887354.1601026817-717469759.1598447085';
        var listvalues = this.getParams(routeURL);          


        if (this.captchaLoaded === true) {

            if (this.getCaptchaResponse === "") {
                this.toastService.error(this.userPersistenceService.generalTranslation.ReCaptchaError);
            }
            else {
                this.form.value.registerPage2.recaptchResponse = this.getCaptchaResponse;
            }
        }

        if (this.form.controls.registerPage2.valid) {
            if (this.form.value.registerPage2.agreeToPrivacyPolicy) {
                this.signup = Object.assign(this.form.value.registerPage1,
                    this.form.value.registerPage2,
                    {
                        userName: this.form.value.registerPage1.email,
                        captchaInput: this.form.value.registerPage2.captchaInput,
                        JobTitleId: this.jobTitleId
                    }
                );

                if (this.form.value.registerPage2.recaptchResponse != undefined) {

                    if (this.captchaLoaded && this.commonDataService.isUndefinedOrNull(this.form.value.registerPage2.recaptcha)) {
                        this.toastService.error(this.userPersistenceService.generalTranslation.ReCaptchaError);
                        this.recaptchaReload();
                        return;
                    }
                    this.authService.register(this.signup)
                        .subscribe((status: any) => {
                            // Call Adwards Service 
                            this.googleService.sendRegisterCustomerConversionToGoogleAnalytics(this.userPersistenceService.selectedLanguage);

                            this.authService.login(this.form.controls.registerPage1.value)
                                .subscribe((result: any) => {

                                    if (listvalues != null && ((listvalues[0] != undefined || listvalues["client_id"] != undefined)) || this.router.url === '/ifc/learn') {

                                        if (listvalues["client_id"] && listvalues["client_id"] === 'RURHRUxNU0ludGVncmF0aW9u') {


                                            let url = this.lmsUrl;

                                            if (listvalues['redirect_uri'] && listvalues['client_id'] && listvalues['response_type']) {
                                                url = listvalues['redirect_uri'] + '?client_id=' + listvalues['client_id'] + '&response_type=' + listvalues['response_type'] + '&state=' + listvalues['state'] + '&scope=' + listvalues['scope']
                                            }
                                            this.localStorageService.set('lmsRedirectURL', url);
                                            
                                            this.action.next({ status: 'LMSPortal', response: status });
                                        }
                                        else {
                                            this.toastService.error('Invalid information');
                                        }

                                    } else {                                       
                                        this.action.next({ status: this.confirmationStatus.ok });
                                    }
                                });
                        
                            this.cdr.markForCheck();}, error => {
                            if (error.error.message == "101") {
                                this.toastService.error(this.userPersistenceService.generalTranslation.AlreadyRegister + ' Login');
                            }
                            if (error.error.message == "102" || error.error.message == "103") {
                                this.toastService.error(this.userPersistenceService.generalTranslation.Verification);
                                this.getMathCaptcha();
                                this.signup.captchaInput = '';
                            }
                            else if (error.error.message == "111") {
                                this.toastService.error(this.userPersistenceService.generalTranslation.ErrorMsg);
                            }
                            else if (error.error.message == "112") {
                                this.toastService.error(this.userPersistenceService.generalTranslation.ReCaptchaError);
                                //recaptch reload
                                this.recaptchaReload();
                            }
                            else if (error.error.message == "The request is invalid.") {
                                this.toastService.error(this.userPersistenceService.generalTranslation.MatchPwd);                                
                            }
                        
                            this.cdr.markForCheck();});
                }
                else {
                    this.toastService.error(this.userPersistenceService.generalTranslation.CaptchaResolveMsg);
                }

            }
            else {
                this.toastService.error(this.userPersistenceService.generalTranslation.AgreeTnC);
            }
        }
        else {
            this.formControlService.callFormControlError(<FormGroup>this.form.controls.registerPage2);
        }
    };
}
